var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9.90316C1 14.3777 4.24975 18.0984 8.5 18.8529V12.3527H6.25V9.85291H8.5V7.85266C8.5 5.60266 9.94975 4.35316 12.0002 4.35316C12.6497 4.35316 13.3503 4.45291 13.9998 4.55266V6.85291H12.85C11.7498 6.85291 11.5 7.40266 11.5 8.10316V9.85291H13.9L13.5002 12.3527H11.5V18.8529C15.7502 18.0984 19 14.3784 19 9.90316C19 4.92541 14.95 0.852905 10 0.852905C5.05 0.852905 1 4.92541 1 9.90316Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.6d949c1a83301510d7839df1fbccebde.svg";
export { ForwardRef as ReactComponent };